/**
 * @param {unknown} error
 * @returns {string}
 */
export function getErrorMessage(error) {
  if (!error) return "Something went wrong.";
  if (typeof error === "string") return error;
  const ax = error;
  if (ax && typeof ax === "object") {
    const msg =
      ax.response?.data?.message ||
      ax.response?.data?.error ||
      (Array.isArray(ax.response?.data?.errors) &&
        ax.response.data.errors.map((e) => e?.message || e).filter(Boolean).join(", ")) ||
      ax.message;
    if (typeof msg === "string" && msg.trim()) return msg.trim();
  }
  return "Something went wrong.";
}
